import { useCallback, useEffect, useState } from 'react';
import type { DateSelectorEvents } from '@shared/designSystem/DateSelectorEvents';

interface DateSelectorViewModelProps {
    initialDate?: Date | null;
    events?: DateSelectorEvents;
}

export const useDateSelectorViewModel = ({
    initialDate = null,
    events
}: DateSelectorViewModelProps) => {
    const [selectedDate, setSelectedDate] = useState<Date | null>(initialDate);
    const initialDateTimestamp = initialDate?.getTime() ?? null;

    useEffect(() => {
        setSelectedDate(initialDate ?? null);
    }, [initialDateTimestamp]);

    const handleSelectionChange = useCallback((date: Date | null) => {
        setSelectedDate(date);
        events?.onSelectionChange?.(date);
    }, [events]);

    const handleApplySelection = useCallback(() => {
        events?.onApply?.(selectedDate);
    }, [events, selectedDate]);

    const handleClearSelection = useCallback(() => {
        setSelectedDate(null);
        events?.onSelectionChange?.(null);
        events?.onClear?.();
    }, [events]);

    return {
        selectedDate,
        handleSelectionChange,
        handleApplySelection,
        handleClearSelection
    };
};
